import GroupStoreInfo from '~/pages/StoreInfo';

export default GroupStoreInfo;
